import axiosWrapper from './axiosWrapper'

const URL_CHECK_USUARIO = `api/usuario/userCheck`

const check = (axiosParams) => {
  const url = `${axiosParams.baseURL}/${URL_CHECK_USUARIO}`
  return axiosWrapper.get({ ...axiosParams, url })
}

const serviceUsuario = {
  check
}

export default serviceUsuario
